import pagination from '@/common/components/pagination'

export default {
components: { pagination },
    data: () => ({
        mask_data: '##/##/####',
        mask_cpf: '###.###.###-##',
        mask_rg: '##.###.###-#',
        mask_tel: '####-####',
        mask_cel: '#####-####',
        mask_cep: '#####-###',
        mask_ddd: '##',
        mask_textoPadrao: 'a-z,A-Z,0-9',
        money: {
            decimal: ',',
            thousands: '.',
            precision: 2,
            masked: false,
        },
    }),
    methods: {

        defaultPageChanged(filter, index) {
            filter.pageIndex = index;
            return filter;
        },
        defaultOrderBy(filter, field) {
            let type = 0;
            if (filter.orderByType == 0) type = 1;
            filter.orderFields = field;
            filter.orderByType = type;
            filter.isOrderByDynamic = true;
            return filter;
        },

        defaultSuccessResult(msg) {
            this.hideLoading();
            this.$eventHub.$emit('show-notification', {
                type: 'success',
                title: 'Sucesso',
                text: msg
            })
        },
        defaultErrorResult(err, modal) {
            this.hideLoading();
            if (err.data && err.data.errors) {
                for (var i = 0; i < err.data.errors.length; i++) {
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors[i],
                        modal: modal
                    })
                }
            }

            else
                this.$eventHub.$emit('show-notification', {
                    type: 'error',
                    title: 'Atenção',
                    text: err,
                    modal: modal
                })
        },
        configNotification() {
            this.$eventHub.$on('show-notification', (data) => {
                this.$notify({
                    type: data.type,
                    title: data.title,
                    text: data.text,
                    duration: 10000,
                    speed: 1000
                })
            })
        },
        showLoading() {
            this.$eventHub.$emit('show-loading', true)
        },
        hideLoading() {
            this.$eventHub.$emit('show-loading', false)
        },
        failLoading() {
            this.$eventHub.$emit('show-loading', false)
        },

    },
    mounted() {
        window.scrollTo(0, 0);
    },
}
